import React, { useState } from 'react';
import $ from 'jquery';
import './Account.css';

// ─── Change Password sub-form ─────────────────────────────────────────────────
function ChangePassword({ notifySuccess, notifyError }) {
  const [oldPass, setOldPass]       = useState('');
  const [newPass, setNewPass]       = useState('');
  const [confirmPass, setConfirm]   = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newPass !== confirmPass) {
      notifyError('As senhas não coincidem');
      return;
    }
    $.ajax({
      url: '/api/v1/update/password',
      type: 'PUT',
      data: JSON.stringify({ oldPassword: oldPass, newPassword: newPass, confirmPassword: confirmPass }),
      success(res) { notifySuccess(res.message); setOldPass(''); setNewPass(''); setConfirm(''); },
      error(err)   { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="rs-account-card">
        <label>Senha atual</label>
        <input type="password" value={oldPass} onChange={e => setOldPass(e.target.value)} required />
        <label>Nova senha</label>
        <input type="password" value={newPass} onChange={e => setNewPass(e.target.value)} required />
        <label>Confirmar nova senha</label>
        <input type="password" value={confirmPass} onChange={e => setConfirm(e.target.value)} required />
        <div>
          <button type="submit" className="rs-btn" style={{ marginTop: 4 }}>Atualizar senha</button>
        </div>
      </div>
    </form>
  );
}

// ─── Account page ─────────────────────────────────────────────────────────────
export default function Account({ notifySuccess, notifyError }) {
  const username = localStorage.getItem('username') || '';
  const email    = localStorage.getItem('email') || '';

  const logOut = () => {
    // Clear local storage and cache immediately, then notify the server best-effort
    localStorage.clear();
    sessionStorage.clear();
    window.localStorage.clear();
    window.sessionStorage.clear();
    // Clear browser caches if the Cache API is available
    if ('caches' in window) {
      caches.keys().then(names => names.forEach(name => caches.delete(name)));
    }
    window.location.replace(`${window.location.protocol}//${window.location.host}`);


    // Notify server (fire-and-forget — redirect happens regardless)
    // $.ajax({ url: '/api/v1/logout', type: 'DELETE' }).always(() => {
    //   window.location.replace(`${window.location.protocol}//${window.location.host}`);
    // });
  };

  const restartCloud = (e) => {
    e.preventDefault();
    $.ajax({
      url: '/api/v1/restart/application', type: 'GET',
      success(res) { notifySuccess(res.message); },
      error(err)   { if (err.responseJSON) notifyError(err.responseJSON.message); }
    });
  };

  return (
    <div>
      <h2 className="rs-account-title">Minha Conta</h2>

      {/* Name */}
      <div className="rs-account-card">
        <label>Nome</label>
        <input type="text" defaultValue={username} readOnly />
      </div>

      {/* Email */}
      <div className="rs-account-card">
        <label>Email de cadastro</label>
        <input type="email" defaultValue={email} readOnly />
      </div>

      {/* Change password */}
      <ChangePassword notifySuccess={notifySuccess} notifyError={notifyError} />

      {/* Manager */}
      <div className="rs-account-manager">
        <h3>Manager</h3>
        <button className="rs-btn" onClick={restartCloud}>Reiniciar a nuvem</button>
      </div>

      {/* Logout */}
      <button className="rs-logout-btn" onClick={logOut}>Logout</button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/DashboardPage/Account/Account.js